module.exports = __webpack_public_path__ + "img/slide-1.91794ba9.webp";